oyc.StageFilter = {
  dependencies: ['Dropdown'],
  selectors: {
    container: '#entry-tool',
    careerLevelWrap: '#et-career-level',
    categoryWrap: '#et-category',
    careerLevel: '.et-career-level',
    category: '.et-category',
    submitButton: 'button[type="submit"]'
  },
  optionMap: oyc.static.EntryTool || [],
  state: {
    selectedCareerIndex: 0,
    selectedCategoryId: null
  },
  container: null,
  init: function () {
    this.container = $(this.selectors.container);
    if (this.container.length === 0) return;

    this.careerLevelWrap = this.container.find(this.selectors.careerLevelWrap);
    this.careerLevel = this.container.find(this.selectors.careerLevel);
    this.categoryWrap = this.container.find(this.selectors.categoryWrap);
    this.category = this.container.find(this.selectors.category);
    this.submitButton = this.container.find(this.selectors.submitButton);
    document.addEventListener('oyc:dropdown:initDropdowns', this.initDropdowns.bind(this));
  },

  initDropdowns: function () {
    this.careerLevel.dropdown('setting', {
      onChange: function (value, text, choice) {
        console.log('career-level change');
        const idxRaw = choice && choice.length ? choice.data('index') : null;
        const idx = Number.isFinite(Number(idxRaw)) ? Number(idxRaw) : 0;
        this.applyCareerLevelByIndex(idx);
      }.bind(this)
    });

    this.category.dropdown('setting', {
      onChange: function (value) {
        console.log('category change');
        this.state.selectedCategoryId = value ? String(value) : null;
        this.updateSubmitButton();
      }.bind(this)
    });
    this.applyCareerLevelByIndex(0);
  },
  applyCareerLevelByIndex: function (index) {
    const cfg = this.optionMap[index];
    this.state.selectedCareerIndex = index;

    // Sicherheitsnetz
    if (!cfg) {
      this.toggleCategory(false, cfg);
      this.updateSubmitButton(0);
      return;
    }

    // Kategorie-Field anzeigen/verstecken (Property "category" aus JSON)
    this.toggleCategory(!!cfg.category, cfg);

    // Kategorien dynamisch auf die "in use" Kategorien dieses Career-Levels begrenzen
    this.updateSubmitButton();
  },

  toggleCategory: function (show, cfg) {
    if (!this.categoryWrap || this.categoryWrap.length === 0) return;

    if (show) {
      this.categoryWrap.removeClass('hide').attr('aria-hidden', 'false');
      if (cfg) {
        this.filterCategoryMenu(cfg);
      }
    } else {
      this.categoryWrap.addClass('hide').attr('aria-hidden', 'true');
      this.state.selectedCategoryId = null;
      this.category.dropdown('clear');
      this.category.dropdown('restore default text');
    }
  },

  filterCategoryMenu: function (cfg) {
    if (!this.category || this.category.length === 0) return;

    const menu = this.category.find('.menu');
    if (menu.length === 0) return;

    let visibleItems = [];
    menu.find('.item').each(function () {
      const item = $(this), itemCareerLevels = item.attr('data-career-level').split(',').map(s => parseInt(s.trim())).filter(Boolean);
      if (cfg.value.length === 0 || cfg.value.some(
        val => itemCareerLevels.includes(val)
      )) {
        item.show();
        visibleItems.push(item.attr('data-value'));
      } else {
        item.hide();
      }
    });

    this.category.dropdown('refresh');
    const current = this.state.selectedCategoryId;
    if (current && visibleItems.indexOf(current) !== -1) {
      this.category.dropdown('set selected', String(current));
    } else {
      const first = visibleItems.length ? String(visibleItems[0]) : null;
      this.state.selectedCategoryId = first;
      if (first) {
        this.category.dropdown('set selected', first);
      } else {
        this.category.dropdown('clear');
        this.category.dropdown('restore default text');
      }
    }
  },

  updateSubmitButton: function () {
    if (!this.submitButton || this.submitButton.length === 0) return;

    const cfg = this.optionMap[this.state.selectedCareerIndex] || null;

    let count = 0;
    if (cfg && cfg.count) {
      if (cfg.category && this.state.selectedCategoryId) {
        count = (cfg.count.categories && cfg.count.categories[this.state.selectedCategoryId])
          ? Number(cfg.count.categories[this.state.selectedCategoryId])
          : 0;
      } else {
        count = cfg.count.sum ? Number(cfg.count.sum) : 0;
      }
    }

    const noun = (count === 1) ? 'Angebot' : 'Angebote';
    this.submitButton.text(`${count} ${noun} anzeigen`);

    // UX: Bei 0 deaktivieren
    this.submitButton.prop('disabled', count === 0);
  }
}
